import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import { api } from '../../lib/api';
import { Reveal } from '../Reveal';
import { Label } from './Label';

export default function BookFeature({ accent = '#FBBF24', compact = false }) {
  const [book, setBook] = useState(null);
  useEffect(() => { api.get('/books').then((r) => setBook(r.data[0] || null)).catch(() => {}); }, []);
  if (!book) return null;
  return (
    <Reveal>
      <Link to={`/u99/book/${book.slug}`} className="group block rounded-3xl border p-7 lg:p-10 transition-colors duration-500 relative overflow-hidden" style={{ borderColor: `${accent}40` }} data-testid="book-feature-card">
        <span className="absolute -right-6 -top-8 font-celestial text-[9rem] leading-none text-white/[0.025] select-none">§</span>
        <div className="flex flex-wrap items-center gap-4">
          <span className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.3em]" style={{ color: accent }}><BookOpen size={13} /> The foundational book</span>
          <Label id={book.label} size="xs" />
        </div>
        <h3 className="mt-5 font-celestial text-3xl sm:text-4xl text-slate-100 leading-tight group-hover:text-amber-100 transition-colors">{book.title}</h3>
        <p className="mt-2 font-celestial text-lg italic text-amber-200/70">{book.subtitle}</p>
        {!compact && <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed max-w-2xl">{book.description}</p>}
        <div className="mt-7 flex flex-wrap items-center gap-6">
          <span className="font-mono-precision text-[10px] uppercase tracking-[0.2em] text-slate-500">{book.chapters.length} chapters · {book.chapters_ready} transcribed</span>
          <span className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.25em] group-hover:translate-x-1 transition-transform" style={{ color: accent }}>Open the book <ArrowRight size={12} /></span>
        </div>
      </Link>
    </Reveal>
  );
}
